import { render, staticRenderFns } from "./bigData_bidIllegal.vue?vue&type=template&id=1e2ae556&scoped=true"
import script from "./bigData_bidIllegal.vue?vue&type=script&lang=js"
export * from "./bigData_bidIllegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ae556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2ae556')) {
      api.createRecord('1e2ae556', component.options)
    } else {
      api.reload('1e2ae556', component.options)
    }
    module.hot.accept("./bigData_bidIllegal.vue?vue&type=template&id=1e2ae556&scoped=true", function () {
      api.rerender('1e2ae556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/bigData/bigData_bidIllegal.vue"
export default component.exports